export default "__VITE_ASSET__3921270f__"